<template>
    <div>
      <!-- Breadcrumb -->
      <div class="breadcrumb-list">
        <ol class="breadcrumb">
          <li class="breadcrumb-item active">Dashboard</li>
        </ol>
      </div>

      <!-- White card container -->
      <div class="main-box two-column">
        <div class="emplyee-info-wrp bg-transparent p-0">
          <!-- Dashboard buttons -->
          <div class="dashboard-buttons">
            <!-- Button 1: My Profile -->
            <router-link
              :to="{ path: '/employee/profile/' + uuid }"
              :class="{ disabledClass: companyStatusDisabled, active: my_profile }"
              tag="button"
              class="nav-item"
              @click="activeCompo"
              style="
                padding: 10px;
                background-color: #3498db;
                color: #ffffff;
                border: none;
                border-radius: 5px;
                cursor: pointer;
                outline: none;
              "
            >
              My Profile
            </router-link>

            <!-- Button 2: Attendance -->
            <router-link
              :to="{ name: 'attendance/punchin' }"
              :class="{ disabledClass: companyStatusDisabled, active: attendance_punchin }"
              class="nav-item"
              @click="activeCompo"
              v-if="user && user.type === 'EMPLOYEE'"
              tag="button"
              style="
                padding: 10px;
                background-color: #3498db;
                color: #ffffff;
                border: none;
                border-radius: 5px;
                cursor: pointer;
                outline: none;
                text-decoration: none;
              "
            >
              Attendance
            </router-link>

            <!-- Button 3: My Timesheets -->
            <button
              @click="$router.push({ path: '/timesheet/add/' + user.uuid })"
              style="
                padding: 10px;
                background-color: #3498db;
                color: #ffffff;
                border: none;
                border-radius: 5px;
                cursor: pointer;
                outline: none;
                text-decoration: none;
              "
            >
              My Timesheets
            </button>
          </div>
        </div>
      </div>
    </div>
  </template>


<script>
import moment from "moment";
import logout from "../Settings/Partials/logout";
import axios from "axios";
import Swal from "sweetalert2";
// import stripeCard from "../Membership/stripeCard";
export default {
  name: "Header",
  components: {
    logout,
    // stripeCard
  },
  data() {
    return {
      benefitFrom: {
        company_id: "",
        benefitCategoryIds: [],
        benefitCategoryDescription: [],
      },

      allEventsLogs: [],
      notificationLogs: [],
      companyStatusDisabled: false,
      isTemporaryBlock: false,
      isCardDetail: false,
      dashboard: false,
      employee: false,
      profile_nav: false,
      company_profile: false,
      salary_calc_nav: false,
      comp_profile_nav: false,
      attendance_punchin: false,
      reports_nav: false,
      timesheet_nav: false,
      partner_features: false,
      upgrade_membership: false,
      leave_nav: false,
      messages_nav: false,
      user: this.$store.getters.getUser ? this.$store.getters.getUser : "",
      user_id: this.$store.getters.getUser
        ? this.$store.getters.getUser.id
        : "",
      uuid: this.$store.getters.getUser ? this.$store.getters.getUser.uuid : "",
      company: this.$store.getters.getSelectedCompany,
      company_id: this.$store.getters.getSelectedCompany.id,
      companyMembership: {},
      companyPartner: {},
      isPartner: false,
      isReferBY: false,
      inviteModel: false,
      notifiLength: [],
      benefitCategories: [],
    };
  },
  computed: {},
  created() {
    this.getCompany();
    this.getCompanyPartner();
    this.getCompanyMembership();
    this.getBenefitCategories();
    this.activeCompo();
    this.getallEventsLogs();
    this.getLogs();
    if (
      JSON.parse(localStorage.getItem("user")) == null &&
      localStorage.getItem("isLogin") == 1
    ) {
      this.logout();
    }

    if (
      this.user.refer_by == "ptcl" ||
      this.$store.getters.getSelectedCompany.partner_customer_no != null
    ) {
      this.isReferBY = true;
    }
    if (localStorage.getItem("isLogin") == 1) {
      const recaptchaScript = document.createElement("script");
      recaptchaScript.setAttribute(
        "src",
        "https://js-na1.hs-scripts.com/23315391.js"
      );
      document.head.appendChild(recaptchaScript);
    }

    this.$root.$on("activeCompoClick", () => {
      this.activeCompo();
    });
  },
  mounted() {},

  methods: {
    getCompany() {
      this.id = this.$store.getters.getSelectedCompany.id;
      this.$axios
        .get(this.$GetCompany.replace(":id", this.id), {
          headers: this.getAuthHeader(),
        })
        .then((response) => {
          if (response.data.result.company.status === 0) {
            this.isTemporaryBlock = true;
            this.companyStatusDisabled = true;
            $("#myModalTemporaryBlock")
              .modal({ backdrop: "static", keyboard: false })
              .modal("show");
          } /*else if(response.data.result.company.country !="Pakistan" && (response.data.result.company.paymentMethod =='' || response.data.result.company.paymentMethod ==null ) ){

          this.isCardDetail=true;
           $('#myModalStripeCardDetail').modal({backdrop: 'static', keyboard: false}).modal('show');
        }*/
        });
    },
    clearInviteReq() {
      this.inviteModel = false;
    },
    submitPartnerRequest() {
      // return 1;
      this.benefitFrom.company_id = this.company_id;
      axios
        .post(this.$Partners, this.benefitFrom, {
          headers: this.getAuthHeader(),
        })
        .then((res) => {
          if (res.data.status === 200) {
            if (res.data.result) {
              if (this.isReferBY == false) {
                this.isPartner = true;
              }
            }
            this.inviteModel = false;
            $root.$toast.success(res.data.message);
          } else {
            new Swal({
              title: "Please select!",
              icon: "warning",
              text: "Please select at least one benefit category",
              type: "warning",
              confirmButtonColor: "#3085d6",
              confirmButtonText: "Ok",
            });
          }
        });
    },
    becomePartner() {
      this.inviteModel = true;
    },
    getCompanyPartner() {
      let params = {
        company_id: this.company_id,
      };
      this.$axios
        .get(this.$Partners, {
          params: params,
          headers: this.getAuthHeader(),
        })
        .then((response) => {
          this.companyPartner = response.data.result || [];
          if (this.companyPartner.is_partner == 1) {
            if (this.isReferBY == false) {
              this.isPartner = true;
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getBenefitCategories() {
      this.$axios
        .get(this.$benefitCategories, {
          headers: this.getAuthHeader(),
        })
        .then((response) => {
          this.benefitCategories = response.data.result || [];
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getCompanyMembership() {
      let params = {
        company_id: this.company_id,
      };
      this.$axios
        .get(this.$CompanyMembership, {
          params: params,
          headers: this.getAuthHeader(),
        })
        .then((response) => {
          this.companyMembership = response.data.result || [];
        })
        .catch((error) => {
          console.log(error);
        });
    },

    readTheNotification(id) {
      this.$axios({
        method: "post",
        data: {
          id: id,
        },
        url: this.$ReadTheNotification,
        headers: this.getAuthHeader(),
      }).then((res) => {
        if (res.data.status == 200) {
          this.$router.push({ name: "requests" });
          this.getallEventsLogs();
          // $root.$toast.success(res.data.message);
        }
      });
    },
    getallEventsLogs() {
      this.$axios({
        method: "get",
        params: {
          company_id: this.$store.getters.getSelectedCompany.id,
        },
        url: this.$allRequestLogs,
        headers: this.getAuthHeader(),
      }).then((res) => {
        if (res.status == 200) {
          this.allEventsLogs = res.data.result;
          this.notifiLength = this.allEventsLogs.filter(
            (item) => item.is_read === 0
          );

          this.allEventsLogs.sort((a, b) => (a > b ? 1 : -1));
        }
      });
    },
    getLogs() {
      this.$axios({
        method: "get",
        params: {
          company_id: this.$store.getters.getSelectedCompany.id,
        },
        url: this.$Logs,
        headers: this.getAuthHeader(),
      }).then((res) => {
        if (res.status === 200) {
          this.notificationLogs = res.data.result;
          this.notifiLength = this.notificationLogs.filter(
            (item) => item.is_read === 0
          );
          this.notificationLogs.sort((a, b) => (a > b ? 1 : -1));
        }
      });
    },
    changeUserSelectedComp(id) {
      var currentPath = this.$route.path.replace("/", "");

      this.$axios({
        method: "get",
        params: {
          company_id: id,
          user_id: this.user_id,
        },
        url: this.$ChangeSelectedComp,
        headers: this.getAuthHeader(),
      }).then((res) => {
        if (res.data.status == 200) {
          this.dashboard = true;
          this.employee = false;
          this.profile_nav = false;
          this.company_profile = false;
          this.salary_calc_na = false;
          this.comp_profile_nav = false;
          this.attendance_punchin = false;
          this.reports_nav = false;
          this.timesheet_nav = false;
          this.partner_features = false;
          this.upgrade_membership = false;
          this.leave_nav = false;
          this.$store.commit("setUser", res.data.result);
          if (currentPath == "dashboard") {
            this.$root.$emit("reloadDashboardOnChangeComp");
          }
          this.$router.push({ name: "dashboard" });
          //  this.$router.go(0);
        }
      });
    },
    activeCompo() {
      var currentPath = this.$route.path.replace("/", "");
      this.dashboard =
        currentPath == "dashboard" || currentPath == "schedule" ? true : false;
      this.salary_calc_nav =
        currentPath == "salary-list" || "salary-calculator" ? true : false;
      if (currentPath == "salary-list") {
        this.salary_calc_nav = true;
      } else if (currentPath == "salary-calculator") {
        this.salary_calc_nav = true;
      } else {
        this.salary_calc_nav = false;
      }
      this.comp_profile_nav = currentPath == "company-profile" ? true : false;
      this.attendance_punchin =
        currentPath == "attendance-punchin" ? true : false;
      this.reports_nav = currentPath == "reports/attendance" ? true : false;
      this.timesheet_nav =
        currentPath == "timesheets" ||
        currentPath == "timesheet/customers" ||
        currentPath == "timesheet/projects"
          ? true
          : false;
      this.leave_nav = currentPath == "leaves" ? true : false;
      this.partner_features =
        currentPath == "partner/product-items" ||
        currentPath == "partner/transactions"
          ? true
          : false;
      this.messages_nav = currentPath == "messages/inbox" ? true : false;
      this.upgrade_membership =
        currentPath == "upgrade-membership" ? true : false;
      if (
        this.uuid == this.$route.params.id &&
        this.$route.path.startsWith("/employee/profile")
      ) {
        this.profile_nav = true;
        this.employee = false;
      } else {
        if (
          currentPath === "employees" ||
          this.$route.path.startsWith("/employee/")
        ) {
          this.employee = true;
        } else {
          this.employee = false;
        }
        this.profile_nav = false;
      }
      currentPath = "";
    },
    logout() {
      return this.$axios
        .get(this.$Logout, {
          headers: this.getAuthHeader(),
        })
        .then((response) => {
          localStorage.setItem("isLogin", 0);
          this.$store.commit("logoutUser");
          setTimeout(() => {
            this.$router.push({ name: "login" });
          }, 2000);
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>
<style>
.disabledClass {
  pointer-events: none;
  opacity: 0.9;
}
.nav-head .navbar-second .nav-link {
  text-transform: capitalize !important;
}

.nav-head .dropdown-item {
  text-transform: capitalize !important;
}
.myModalTemporaryBlock {
  position: relative;
  z-index: 1;
  margin-top: 67px;
}
.top-nav {
  position: relative;
  z-index: 9999;
}
.myModalTemporaryBlock:before {
  content: "";
  position: absolute;
  left: 0;
  width: 100%;
  top: 0;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  z-index: -1;
}
</style>
